/**
 * Settings form markup for the Button Dropdown component.
 *
 * Authored as a plain markup object (the declarative `settingsFormMarkup`
 * approach). The button list itself is configured with the native
 * `buttonGroupConfigurator` input, so every dropdown button gets the full
 * Shesha action picker (navigate / execute script / show dialog / submit …).
 */
export const getSettings = (): any => ({
  components: [
    {
      id: "5f0c0a10-0001-4a01-8a01-000000000001",
      type: "sectionSeparator",
      propertyName: "sepTrigger",
      parentId: "root",
      label: "Trigger Button",
    },
    {
      id: "5f0c0a10-0002-4a01-8a01-000000000002",
      type: "textField",
      propertyName: "caption",
      parentId: "root",
      label: "Button Text",
    },
    {
      id: "5f0c0a10-0003-4a01-8a01-000000000003",
      type: "iconPicker",
      propertyName: "icon",
      parentId: "root",
      label: "Button Icon",
    },
    {
      id: "5f0c0a10-0004-4a01-8a01-000000000004",
      type: "dropdown",
      propertyName: "buttonType",
      parentId: "root",
      label: "Button Type",
      dataSourceType: "values",
      values: [
        { id: "5f0c0a10-0004-0001-0000-000000000001", label: "Default", value: "default" },
        { id: "5f0c0a10-0004-0002-0000-000000000002", label: "Primary", value: "primary" },
        { id: "5f0c0a10-0004-0003-0000-000000000003", label: "Dashed", value: "dashed" },
        { id: "5f0c0a10-0004-0004-0000-000000000004", label: "Link", value: "link" },
        { id: "5f0c0a10-0004-0005-0000-000000000005", label: "Text", value: "text" },
      ],
    },
    {
      id: "5f0c0a10-0005-4a01-8a01-000000000005",
      type: "dropdown",
      propertyName: "size",
      parentId: "root",
      label: "Button Size",
      dataSourceType: "values",
      values: [
        { id: "5f0c0a10-0005-0001-0000-000000000001", label: "Small", value: "small" },
        { id: "5f0c0a10-0005-0002-0000-000000000002", label: "Middle", value: "middle" },
        { id: "5f0c0a10-0005-0003-0000-000000000003", label: "Large", value: "large" },
      ],
    },
    {
      id: "5f0c0a10-0006-4a01-8a01-000000000006",
      type: "switch",
      propertyName: "danger",
      parentId: "root",
      label: "Danger",
    },
    {
      id: "5f0c0a10-0007-4a01-8a01-000000000007",
      type: "switch",
      propertyName: "block",
      parentId: "root",
      label: "Full Width",
    },
    {
      id: "5f0c0a10-0008-4a01-8a01-000000000008",
      type: "sectionSeparator",
      propertyName: "sepBehaviour",
      parentId: "root",
      label: "Dropdown Behaviour",
    },
    {
      id: "5f0c0a10-0009-4a01-8a01-000000000009",
      type: "dropdown",
      propertyName: "trigger",
      parentId: "root",
      label: "Open On",
      dataSourceType: "values",
      values: [
        { id: "5f0c0a10-0009-0001-0000-000000000001", label: "Click", value: "click" },
        { id: "5f0c0a10-0009-0002-0000-000000000002", label: "Hover", value: "hover" },
      ],
    },
    {
      id: "5f0c0a10-000a-4a01-8a01-00000000000a",
      type: "dropdown",
      propertyName: "placement",
      parentId: "root",
      label: "Placement",
      dataSourceType: "values",
      values: [
        { id: "5f0c0a10-000a-0001-0000-000000000001", label: "Bottom Left", value: "bottomLeft" },
        { id: "5f0c0a10-000a-0002-0000-000000000002", label: "Bottom", value: "bottom" },
        { id: "5f0c0a10-000a-0003-0000-000000000003", label: "Bottom Right", value: "bottomRight" },
        { id: "5f0c0a10-000a-0004-0000-000000000004", label: "Top Left", value: "topLeft" },
        { id: "5f0c0a10-000a-0005-0000-000000000005", label: "Top", value: "top" },
        { id: "5f0c0a10-000a-0006-0000-000000000006", label: "Top Right", value: "topRight" },
      ],
    },
    {
      id: "5f0c0a10-000b-4a01-8a01-00000000000b",
      type: "sectionSeparator",
      propertyName: "sepButtons",
      parentId: "root",
      label: "Buttons",
    },
    {
      id: "5f0c0a10-000c-4a01-8a01-00000000000c",
      type: "settingsInput",
      inputType: "buttonGroupConfigurator",
      propertyName: "items",
      parentId: "root",
      label: "Configure Buttons",
    },
    {
      id: "5f0c0a10-000d-4a01-8a01-00000000000d",
      type: "sectionSeparator",
      propertyName: "sepVisibility",
      parentId: "root",
      label: "Visibility",
    },
    {
      id: "5f0c0a10-000e-4a01-8a01-00000000000e",
      type: "switch",
      propertyName: "hidden",
      parentId: "root",
      label: "Hidden",
    },
  ],
  formSettings: {
    layout: "vertical",
    colon: false,
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  },
});
